import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const KycGeneralApi = createApi({
  reducerPath: "KycGeneralApi",
  baseQuery,
  tagTypes: ["KycGeneral"],

  endpoints: (builder) => ({
    getKycGeneral: builder.query({
      query: ({ id }) =>`customers/kyc/${id}`,
      transformResponse: (response) => response?.data?.[0] ?? [],
      providesTags: ["KycGeneral"],
    }),

    createKycGeneral: builder.mutation({
      query: ({ id, ...data }) => ({
        url:`customers/kyc/${id}`, 
        method: "PUT",
        headers: { 
          "X-Request-Id": Math.random().toString(36).substring(2)
        },
        body: { kycGeneral: data },
      }),
      invalidatesTags: ["KycGeneral"],
    }),
 
  }),
});

export const {
  useLazyGetKycGeneralQuery,
  useCreateKycGeneralMutation
} = KycGeneralApi;
